/**
 * @file
 * Attaches behaviors for the Contextual module.
 */
(function ($, Drupal) {
  /**
   * Attaches theme behavior.
   */
  Drupal.behaviors.searchBlockForm = {
    attach: function (context, settings) {
      if (context === document) {
        setTimeout(() => {
          $('.top-bar-right .search-button a').click()
        }, 100)
        // console.log('searchBlockForm', settings);
      }
    }
  }
})(jQuery, Drupal)
